/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module SupportModule
 */

import { Injector } from '@angular/core';

const $injector = '$injector';

export const asyncFactoryProvider = {
    deps: [$injector],
    provide: 'AsyncFactory',
    useFactory(injector: Injector): any {
        return injector.get('AsyncFactory');
    },
};
